var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { setErrorMessage } from '@popup/multichain/actions/message.actions';
import { EditMyWitnessComponent } from '@popup/steem/pages/app-container/home/governance/my-witness-tab/edit-my-witness/edit-my-witness.component';
import { WitnessInformationComponent } from '@popup/steem/pages/app-container/home/governance/my-witness-tab/witness-information/witness-information.component';
import WitnessUtils from '@popup/steem/utils/witness.utils';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { SVGIcons } from 'src/common-ui/icons.enum';
import RotatingLogoComponent from 'src/common-ui/rotating-logo/rotating-logo.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
const MyWitnessTab = ({ ranking, globalProperties, activeAccount, currencyPrices, setErrorMessage, }) => {
    const [witnessInfo, setWitnessInfo] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [editMode, setEditMode] = useState(false);
    const [hasError, setHasError] = useState(false);
    useEffect(() => {
        init();
    }, []);
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        try {
            const result = yield WitnessUtils.getWitnessInfo(activeAccount.name, globalProperties, currencyPrices);
            setWitnessInfo(result);
            setIsLoading(false);
        }
        catch (err) {
            setIsLoading(false);
            setHasError(true);
            setErrorMessage('popup_html_error_retrieving_witness_information');
        }
    });
    return (React.createElement("div", { className: "my-witness-tab" },
        !isLoading &&
            witnessInfo &&
            (!editMode ? (React.createElement(WitnessInformationComponent, { ranking: ranking, setEditMode: setEditMode, witnessInfo: witnessInfo })) : (React.createElement(EditMyWitnessComponent, { setEditMode: setEditMode, witnessInfo: witnessInfo }))),
        isLoading && (React.createElement("div", { className: "rotating-logo-container" },
            React.createElement(RotatingLogoComponent, null))),
        hasError && (React.createElement("div", { "aria-label": "error-witness", className: "error-witness" },
            React.createElement(SVGIcon, { className: "error-icon", icon: SVGIcons.MESSAGE_ERROR }),
            React.createElement("span", null, getMessage('popup_html_error_retrieving_witness_information'))))));
};
const mapStateToProps = (state) => {
    return {
        activeAccount: state.steem.activeAccount,
        globalProperties: state.steem.globalProperties,
        currencyPrices: state.steem.currencyPrices,
    };
};
const connector = connect(mapStateToProps, {
    setErrorMessage,
});
export const MyWitnessTabComponent = connector(MyWitnessTab);
